import { combineReducers } from "redux";
import { templateReducers } from "./template/TemplateReducers";
import { modelerReducers } from "./modeler/ModelerReducers";
import { modelRunReducers } from "./model-run/ModelRunReducers";
import { userReducers } from "./user/UserReducers";
export const createRootReducer = (history) =>
  combineReducers({
    user: userReducers,
    template: templateReducers,
    modeler: modelerReducers,
    modelRun: modelRunReducers,
  });
